import EntradaTrasladoService from "@/services/inventario/EntradaTrasladoService";

const fetch = (context, params) => {
  return EntradaTrasladoService.fetch(params)
    .then(res => {
      context.commit('ENTRADAS_TRASLADO', res.data);
    });
};

export default {
  fetch,
};